import classNames from 'classnames';
import { camelCase } from 'lodash';
import { useMemo } from 'react';
import tinycolor from 'tinycolor2';

import { useTheme } from '../../contexts/ThemeContext';

import styles from '../../../styles/icons/simon-button.module.scss';

interface SimonButtonIconProps {
    position: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right';
    color?: string;
    shadowColor?: string;
    downColor?: string;
    downShadowColor?: string;
    down?: boolean;
    className?: string;
}

const SimonButtonIcon = ({
    position = 'top-left',
    color = '#aa1f2e',
    shadowColor = null,
    downColor = null,
    downShadowColor = null,
    down = false,
    className = null,
}: SimonButtonIconProps) => {
    const { name: themeName } = useTheme();
    const finalShadowColor = useMemo(
        () => shadowColor || `#${tinycolor(color).darken(20).toHex()}`,
        [shadowColor, color],
    );
    const finalDownColor = useMemo(
        () => downColor || `#${tinycolor(color).lighten(20).toHex()}`,
        [downColor, color],
    );
    const finalDownShadowColor = useMemo(
        () => downShadowColor || `#${tinycolor(finalDownColor).darken(20).toHex()}`,
        [downShadowColor, finalDownColor],
    );
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 110 105"
            className={classNames([
                styles.container,
                styles[camelCase(position)],
                {
                    [styles.down]: down,
                    [styles.withoutShadow]: shadowColor === null,
                    [className]: className !== null,
                },
            ])}
        >
            {themeName === 'coorslive' ? (
                <>
                    <path
                        className={styles.shadow}
                        d="M106.416 1.55139C48.4545 2.73944 1.68811 49.5058 0.5 107.468H59.298C60.2907 81.8951 80.8438 61.3419 106.416 60.3493V1.55139Z"
                        fill={down ? finalDownShadowColor : finalShadowColor}
                    />
                    <path
                        className={styles.top}
                        d="M106.416 0.259766C48.4545 1.44781 1.68811 48.2142 0.5 106.176H59.298C60.2907 80.6034 80.8438 60.0503 106.416 59.0577V0.259766Z"
                        fill={down ? finalDownColor : color}
                    />
                </>
            ) : (
                <>
                    <path
                        className={styles.shadow}
                        d="M120,11.41v48.3c0,.96-.26,1.91-.78,2.73l-33.75,54.87c-1.02,1.66-2.89,2.68-4.92,2.68H5.7c-3.15,0-5.7-2.42-5.7-5.41V11.41c0-2.98,2.54-5.41,5.7-5.41h108.61c3.14,0,5.7,2.42,5.7,5.41Z"
                        fill={down ? finalDownShadowColor : finalShadowColor}
                    />
                    <path
                        className={styles.top}
                        d="M120,5.41v48.3c0,.96-.26,1.91-.78,2.73l-33.75,54.87c-1.02,1.66-2.89,2.68-4.92,2.68H5.7c-3.15,0-5.7-2.43-5.7-5.41V5.41C0,2.42,2.54,0,5.7,0h108.61c3.14,0,5.7,2.42,5.7,5.41Z"
                        fill={down ? finalDownColor : color}
                    />
                </>
            )}
        </svg>
    );
};

export default SimonButtonIcon;
